import classNames from "classnames";
import { useContext, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";

// context
import { ContractContext } from "../../../providers/contract";
import { ROUTES } from "../../../setup/constants";
import LeftSection from "./LeftSection";
import RightSection from "./RightSection";
import ContractAction from "../ContractActions";

// styles
import styles from "./styles.module.scss";
import {
  EContractType,
  ETrasactionsType,
} from "../../../setup/api/services/contract/models";
import { ECONTRACT_STATUS } from "../../../enums";
import PrimaryButton from "../../../components/common/PrimaryButton";
import { useTranslation } from "react-i18next";
import SettlementModal from "./SettlementModal";
import CashoutCard from "../../cashouts/CashoutCard";
import AdvancedSettlementModal from "./AdvancedSettlementModal";
import OperationMetadata from "./OperationMetadata";
import ShippingDetails from "./ShippingDetails";
import LockerShipmentCard from "./LockerShipmentCard";

const AuthenticatedContractDetails = () => {
  const navigate = useNavigate();
  const { id } = useParams();
  const { t } = useTranslation();

  const { contract, actions } = useContext(ContractContext);

  const [openSettlementModal, setOpenSettlementModal] = useState(false);

  const canAdminSettleContract =
    contract &&
    contract?.type !== EContractType.COMPLEX_CONTRACT &&
    (contract.status === ECONTRACT_STATUS.RESOLVED_REFUND_CUSTOMER ||
      contract.status === ECONTRACT_STATUS.RESOLVED_RELEASE_PROVIDER ||
      contract.status === ECONTRACT_STATUS.INSPECTION_ESCALATION ||
      contract.status === ECONTRACT_STATUS.DELIVERY_ESCALATION ||
      contract.status === ECONTRACT_STATUS.WAITING_FOR_SETTLEMENT_CLOSE ||
      contract.status === ECONTRACT_STATUS.WAITING_FOR_SETTLEMENT_RESOLVE ||
      contract.status === ECONTRACT_STATUS.ITEM_ACCEPTED ||
      contract.status === ECONTRACT_STATUS.READY_FOR_CASH_OUT);

  const viewCashoutCards =
    contract?.status === ECONTRACT_STATUS.CASH_OUT_APPROVED ||
    contract?.status === ECONTRACT_STATUS.PARTIAL_CASHOUT;

  const handleSettlementButton = () => {
    setOpenSettlementModal(true);
  };

  const handleCloseSettlementModal = () => {
    setOpenSettlementModal(false);
  };

  const refreshContractDetails = () => {
    if (id) {
      if (
        contract?.transactions?.some(
          (transaction) =>
            transaction?.type === ETrasactionsType.CUSTOMER_PAY &&
            (transaction?.paymentMethod === "TABBY" ||
              transaction?.paymentMethod === "NEO" ||
              transaction?.paymentMethod === "TAMARA")
        )
      )
        setTimeout(() => actions?.getContract(), 1000);
      else actions?.getContract();
    }
  };

  const back = () => {
    try {
      const searchParams = new URLSearchParams(location?.search);
      const back = searchParams?.get("back")?.trim();
      if (back === "settlements") {
        navigate(ROUTES.SETTLEMENTS);
        return;
      } else if (back === "contract") {
        navigate(ROUTES.CONTRACTS_LIST);
        return;
      }
      if (window?.history?.state) {
        navigate(-1);
      } else navigate(ROUTES.HOME);
    } catch (error) {
      navigate(ROUTES.HOME);
    }
  };

  return (
    <div className={classNames(styles["outter_container"])}>
      <OperationMetadata />
      {contract && (
        <div className={styles["container"]}>
          <div className={styles["left_section"]}>
            <div className={classNames(styles["card"])}>
              <RightSection
                backHandler={back}
                feedBack={refreshContractDetails}
              />
              <ContractAction />
            </div>
            {canAdminSettleContract && (
              <div className={classNames(styles["card"])}>
                <div className={styles["cashout_btn_container"]}>
                  <PrimaryButton
                    style={{
                      maxWidth: "336px",
                      backgroundColor: "#0D44AD",
                      height: "44px",
                      fontSize: "1rem",
                    }}
                    onClick={handleSettlementButton}>
                    {t("global_status_settlement")}
                  </PrimaryButton>
                </div>
              </div>
            )}
            {viewCashoutCards && (
              <div className={styles.cashout_cards_container}>
                <h1 className={classNames(styles["h1"])}>
                  {t("lbl_the_settlement")}
                </h1>
                {contract?.cashOutAmountList?.map((cashOutAmount, index) => {
                  return (
                    <CashoutCard
                      key={index}
                      cashOutAmount={cashOutAmount}
                      disableCashout={cashOutAmount?.multiCashOut}
                      hideFees={
                        contract.type !== EContractType.QUICK_TRANSACTION
                      }
                    />
                  );
                })}
              </div>
            )}
          </div>
          <div className={styles["right_section"]}>
            <ShippingDetails />
            {contract.shipment?.isLocker &&
              contract.status !== ECONTRACT_STATUS.CREATED &&
              contract.status !== ECONTRACT_STATUS.SUBMITTED &&
              contract.status !== ECONTRACT_STATUS.PARTIALLY_PAID &&
              contract.status !==
                ECONTRACT_STATUS.PENDING_PAYMENT_VERIFICATION &&
              contract.status !== ECONTRACT_STATUS.DRAFT &&
              contract.status !== ECONTRACT_STATUS.ADDING_PARTY &&
              contract.status !== ECONTRACT_STATUS.OUT_OF_STOCK &&
              contract.status !== ECONTRACT_STATUS.CANCELED &&
              contract.status !== ECONTRACT_STATUS.DELETED &&
              contract.status !== ECONTRACT_STATUS.ARCHIVED &&
              contract.status !== ECONTRACT_STATUS.CONTRACT_REJECTED && (
                <LockerShipmentCard shipment={contract.shipment} />
              )}
            <div className={classNames(styles["card"])}>
              <LeftSection
                contract={contract}
                refreshContractDetails={refreshContractDetails}
              />
            </div>
          </div>
        </div>
      )}
      <SettlementModal
        open={openSettlementModal}
        handleClose={handleCloseSettlementModal}
      />
    </div>
  );
};

export default AuthenticatedContractDetails;
